// extracted by mini-css-extract-plugin
export default {"file-card-menu-list":"style_file-card-menu-list__niXBz","file-card-menu-item":"style_file-card-menu-item__1JhH5","file-card-menu-button":"style_file-card-menu-button__96eC-"};